// packages/shared/src/schemas/booking-flow.ts
import { z } from 'zod';

export const BookingFlowStepSchema = z.enum([
  'date',
  'start_time',
  'end_time',
  'inventory',
  'food',
  'extras',
  'review',
]);

export const InventorySelectionSchema = z.object({
  inventoryItemId: z.string().uuid(),
  venueInventoryId: z.string().uuid(),
  name: z.string(),
  quantity: z.number().int().positive(),
  pricePerSlot: z.number().nonnegative(),
});

export const AddonSelectionSchema = z.object({
  addonId: z.string().uuid(),
  name: z.string(),
  quantity: z.number().int().positive(),
  price: z.number().nonnegative(),
});

export const FoodItemSelectionSchema = z.object({
  foodItemId: z.string().uuid(),
  name: z.string(),
  quantity: z.number().int().positive(),
  unitPrice: z.number().nonnegative(),
});

export const EndTimeOptionSchema = z.object({
  endTime: z.string().regex(/^\d{2}:\d{2}$/),
  durationMinutes: z.number().int().positive(),
  durationLabel: z.string(),
  price: z.number().nonnegative(),
  isRecommended: z.boolean().optional(),
});

export const BookingDraftStateSchema = z.object({
  venueId: z.string().uuid(),
  venueName: z.string(),
  venueSlug: z.string(),
  bookingMode: z.enum(['inventory', 'capacity']),
  currentStep: BookingFlowStepSchema,
  completedSteps: z.array(BookingFlowStepSchema),
  selectedDate: z.string().regex(/^\d{4}-\d{2}-\d{2}$/).nullable(),
  selectedStartTime: z.string().regex(/^\d{2}:\d{2}$/).nullable(),
  selectedEndTime: z.string().regex(/^\d{2}:\d{2}$/).nullable(),
  durationMinutes: z.number().int().positive().nullable(),
  selectedInventory: z.array(InventorySelectionSchema),
  guestCount: z.number().int().positive(),
  selectedAddons: z.array(AddonSelectionSchema),
  selectedFoodItems: z.array(FoodItemSelectionSchema),
  appliedCouponCode: z.string().nullable(),
  specialRequests: z.string(),
  baseAmount: z.number().nonnegative(),
  inventoryTotal: z.number().nonnegative(),
  foodTotal: z.number().nonnegative(),
  discountAmount: z.number().nonnegative(),
  serviceFee: z.number().nonnegative(),
  taxAmount: z.number().nonnegative(),
  totalAmount: z.number().nonnegative(),
  createdAt: z.number(),
  lastModifiedAt: z.number(),
});

export type BookingDraftStateInput = z.infer<typeof BookingDraftStateSchema>;
